import React from "react";
import { useNavigate } from 'react-router-dom';
import { useLocation } from "react-router-dom";

const ControlPanelButton = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const active = location.pathname === "/";

    const handleClick = () => {
        navigate('/');
    };

    return (
        <button onClick={handleClick} className={active ? "controlpanel-button controlpanel-button-active" : "controlpanel-button"}>
            <i className="bi bi-robot controlpanel-button-overview-icon" style={{ color: "#8E5B9B", position: 'absolute', top: '-18%' }} />
            <span className="controlpanel-button-overview-text" style={{position: 'absolute', bottom: '0%' }}>Styrning</span>
        </button>
    );
};

export default ControlPanelButton;